import Chart from "react-apexcharts";

const ChartComponent = ({ chartData }) => {
  console.log("ChartComponent props:", chartData.additionalProps );
    return (
      <div className={`${chartData.rounded} p-4  bg-white dark:bg-[#17153B] ${chartData.additionalProps.type === "donut" || chartData.additionalProps.type=="pie" ? "" : "dark:border-white border-[1px]" } ${chartData.additionalProps.height == 300 ? "border-t-0": ""} `}>
        <Chart
          options={chartData.options}
          series={chartData.series}
          {...chartData.additionalProps}
        />
      </div>
    );
  };
  
export default  ChartComponent;